var confirmPwd = function(rule, value, callback) {
  if (value === '') {
    callback(new Error('请再次输入密码'));
  } else if (value !== window.$this.formData.newPasswd) {
    callback(new Error('两次输入密码不一致!'));
  } else {
    callback();
  }
};
import Quill from 'quill'; //引入编辑器
var fonts = ['Microsoft-YaHei', 'SimSun', 'SimHei', 'KaiTi', 'Arial', 'Times-New-Roman'];
var Font = Quill.import('formats/font');
Font.whitelist = fonts; //将字体加入到白名单
let util = {
  Base64: {
    _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
    encode: function(input) {
      var output = '';
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      var i = 0;
      input = this._utf8_encode(input);
      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output =
          output +
          this._keyStr.charAt(enc1) +
          this._keyStr.charAt(enc2) +
          this._keyStr.charAt(enc3) +
          this._keyStr.charAt(enc4);
      }
      return output;
    },
    decode: function(input) {
      var output = '';
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      input = input.replace(/[^A-Za-z0-9+/=]/g, '');
      while (i < input.length) {
        enc1 = this._keyStr.indexOf(input.charAt(i++));
        enc2 = this._keyStr.indexOf(input.charAt(i++));
        enc3 = this._keyStr.indexOf(input.charAt(i++));
        enc4 = this._keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }
      }
      output = this._utf8_decode(output);
      return output;
    },
    _utf8_encode: function(string) {
      string = string.replace(/\r\n/g, '\n');
      var utftext = '';
      for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n);
        if (c < 128) {
          utftext += String.fromCharCode(c);
        } else if (c > 127 && c < 2048) {
          utftext += String.fromCharCode((c >> 6) | 192);
          utftext += String.fromCharCode((c & 63) | 128);
        } else {
          utftext += String.fromCharCode((c >> 12) | 224);
          utftext += String.fromCharCode(((c >> 6) & 63) | 128);
          utftext += String.fromCharCode((c & 63) | 128);
        }
      }
      return utftext;
    },
    _utf8_decode: function(utftext) {
      var string = '';
      var i = 0;
      var c,
        c2,
        c3 = 0;
      while (i < utftext.length) {
        c = utftext.charCodeAt(i);
        if (c < 128) {
          string += String.fromCharCode(c);
          i++;
        } else if (c > 191 && c < 224) {
          c2 = utftext.charCodeAt(i + 1);
          string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
          i += 2;
        } else {
          c2 = utftext.charCodeAt(i + 1);
          c3 = utftext.charCodeAt(i + 2);
          string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
          i += 3;
        }
      }
      return string;
    },
    //上传图片文件转base64
    imgFile: function(file) {
      return new Promise(function(resolve, reject) {
        let reader = new FileReader();
        let imgResult = '';
        reader.readAsDataURL(file);
        reader.onload = function() {
          imgResult = reader.result;
        };
        reader.onerror = function(error) {
          reject(error);
        };
        reader.onloadend = function() {
          resolve(imgResult);
        };
      });
    }
  },
  cookieRelative: {
    basic: 'Basic',
    authorization: 'Authorization',
    token: 'X-Auth-Token',
    token_encode: 'X-Auth-Token-Encode',
    userid: 'X-Userid',
    username: 'X-Username',
    userpwd: 'X-Password',
    userrole: 'role',
    tokenTime: '_tokenTime',
    internal: 'message',
    referrer: 'referrer',
    quitsecond: 3000,
    tokenExpires: 7200000,
    pending_confirm: 15,
    pending_kypay_confirmed: 23
  },
  cookie: {
    set: function(key, value, expires) {
      var exp = new Date();
      exp.setTime(exp.getTime() + expires);
      expires = '; expires=' + exp.toGMTString();
      document.cookie = key + '=' + escape(value) + ';expires=' + exp.toGMTString() + ';path=/';
    },
    get: function(key) {
      var arr,
        reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)');
      if ((arr = document.cookie.match(reg))) {
        return unescape(arr[2]);
      } else {
        return null;
      }
    },
    deleteCookie: function(key) {
      if (!key) {
        return false;
      }
      this.set(key, '', -1);
      window.location.href = '/';
    }
  },
  token: {
    quit: function() {
      util.cookie.deleteCookie(util.cookieRelative.token);
    }
  },
  // 数组对象深复制
  deepCopy: function(data) {
    try {
      // 深拷贝
      let o = {
        run: function(val) {
          let result = '';
          if (val instanceof Array) {
            result = this.copyArr(val);
          } else {
            result = this.copyObj(val);
          }
          return result;
        },
        copyArr: function(arr) {
          var arr_temp = [];
          if (arr) {
            for (let i = 0, j = arr.length; i < j; i++) {
              if (arr[i] instanceof Array) {
                arr_temp[i] = this.copyArr(arr[i]);
              } else if (arr[i] instanceof Object) {
                arr_temp[i] = this.copyObj(arr[i]);
              } else arr_temp[i] = arr[i];
            }
          }
          return arr_temp;
        },
        copyObj: function(obj) {
          let obj_temp = {};
          for (let key in obj) {
            if (obj[key] instanceof Array) {
              obj_temp[key] = this.copyArr(obj[key]);
            } else if (obj[key] instanceof Object) {
              obj_temp[key] = this.copyObj(obj[key]);
            } else obj_temp[key] = obj[key];
          }
          return obj_temp;
        }
      };
      return o.run(data);
    } catch (error) {
      try {
        console.error(error);
        return JSON.parse(JSON.stringify(data));
      } catch (error) {
        console.error(error);
        return data;
      }
    }
  },
  // 获取省
  getProvince() {
    return new Promise(resolve => {
      window.$this.osg.ajax(
        'area/query.do',
        {
          _all: '1',
          notFilterOrgId: '1',
          notFilterTenantId: '1',
          level: '1',
          sortField: 'code',
          sortOrder: 'asc'
        },
        res => {
          res.data.map(item => {
            item.value = item.code;
            item.label = item.name;
          });
          resolve(res.data);
        },
        {
          noload: true
        }
      );
    });
  },
  // 获取市
  getCity(parentCode) {
    return new Promise(resolve => {
      window.$this.osg.ajax(
        'area/query.do',
        {
          _all: '1',
          notFilterOrgId: '1',
          notFilterTenantId: '1',
          parentCode,
          level: '2',
          sortField: 'code',
          sortOrder: 'asc'
        },
        res => {
          res.data.map(item => {
            item.value = item.code;
            item.label = item.name;
          });
          resolve(res.data);
        },
        {
          noload: true
        }
      );
    });
  },
  // 获取区
  getDistrict(parentCode) {
    return new Promise(resolve => {
      window.$this.osg.ajax(
        'area/query.do',
        {
          _all: '1',
          notFilterOrgId: '1',
          notFilterTenantId: '1',
          parentCode,
          level: '3',
          sortField: 'code',
          sortOrder: 'asc'
        },
        res => {
          res.data.map(item => {
            item.value = item.code;
            item.label = item.name;
            // item.leaf = true;
          });
          resolve(res.data);
        },
        {
          noload: true
        }
      );
    });
  },
  getSubdistrict(parentCode, arr = [], savedStreet) {
    return new Promise(resolve => {
      window.$this.osg.ajax(
        'area/query.do',
        {
          _all: '1',
          notFilterOrgId: '1',
          notFilterTenantId: '1',
          parentCode,
          level: '4',
          sortField: 'code',
          sortOrder: 'asc'
        },
        res => {
          res.data.map(item => {
            item.value = item.code;
            item.label = item.name;
            item.leaf = true;
            // item.disabled = arr.indexOf(item.value) !== -1
            item.disabled = !savedStreet.includes(item.value) && arr.indexOf(item.value) !== -1;
          });
          resolve(res.data);
        },
        {
          noload: true
        }
      );
    });
  },
  // 校验规则
  rules: {
    code: [
      {
        required: true,
        pattern: /^[\w\d_-]+$/,
        message: '编号填写有误，只能由英文、数字、下划线组成',
        trigger: 'blur'
      }
    ],
    name: [
      {
        required: true,
        message: '不能为空',
        trigger: 'blur'
      }
    ],
    phone: [
      {
        required: true,
        pattern: /^1[3456789]\d{9}$/,
        message: '请输入正确的手机号码',
        trigger: ['blur', 'change']
      }
    ],
    email: [
      {
        type: 'email',
        message: '请输入正确的邮箱地址',
        trigger: ['blur', 'change']
      }
    ],
    website: [
      {
        // required: true,
        pattern: /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~/])+$/,
        message: '请输入正确的网址',
        trigger: ['blur']
      }
    ],
    url: [
      {
        // required: true,
        pattern: /^https?:\/\/(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*$/i,
        message: '请输入正确的网址',
        trigger: ['blur']
      }
    ],
    domainName: [
      {
        // required: true,
        pattern: /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/,
        message: '请输入正确的域名',
        trigger: ['blur']
      }
    ],
    address: [
      {
        required: true,
        message: '请输入地址',
        trigger: 'blur'
      }
    ],
    applyTime: [
      {
        required: true,
        message: '请选择预约时间',
        trigger: 'blur'
      }
    ],
    passwd: [
      {
        required: true,
        message: '密码不能为空',
        trigger: 'change'
      },
      {
        min: 6,
        message: '密码至少6位',
        trigger: 'change'
      }
    ],
    accountPwd: [
      {
        required: true,
        message: '密码不能为空',
        trigger: 'change'
      },
      {
        min: 6,
        message: '密码至少6位',
        trigger: 'change'
      }
    ],
    roleIds: [
      {
        required: true,
        message: '角色不能为空',
        trigger: 'blur'
      }
    ],
    type: [
      {
        required: true,
        message: '类型不能为空',
        trigger: 'blur'
      }
    ],
    value: [
      {
        required: true,
        message: '值不能为空',
        trigger: 'blur'
      }
    ],
    order: [
      {
        required: true,
        pattern: /^\d+$/,
        message: '请输入数字',
        trigger: ['blur', 'change']
      }
    ],
    clientType: [
      {
        required: true,
        message: '客户端不能为空',
        trigger: ['blur', 'change']
      }
    ],
    actCode: [
      {
        required: true,
        message: '套餐等级不能为空',
        trigger: ['blur', 'change']
      }
    ],
    title: [
      {
        required: true,
        message: '标题不能为空',
        trigger: 'blur'
      }
    ],
    content: [
      {
        required: true,
        message: '内容不能为空',
        trigger: 'blur'
      }
    ],
    oldPasswd: [
      {
        required: true,
        message: '请输入当前密码',
        trigger: 'blur'
      },
      {
        min: 6,
        message: '长度至少6位',
        trigger: 'blur'
      }
    ],
    newPasswd: [
      {
        required: true,
        message: '请输入新密码',
        trigger: 'blur'
      },
      {
        min: 6,
        message: '长度至少6位',
        trigger: 'blur'
      }
    ],
    newPasswd2: [
      {
        required: true,
        validator: confirmPwd,
        trigger: 'blur'
      },
      {
        min: 6,
        message: '长度至少6位',
        trigger: 'blur'
      }
    ],
    roleId: [
      {
        required: true,
        message: '角色不能为空',
        trigger: ['blur', 'change']
      }
    ],
    description: [
      {
        required: false,
        message: '不能为空',
        trigger: ['blur', 'change']
      }
    ],
    receiveId: [
      //通知接收人
      {
        required: true,
        message: '接收人不能为空',
        trigger: ['blur', 'change']
      }
    ],
    addressType: [
      {
        required: true,
        message: '地址类型不能为空',
        trigger: ['blur', 'change']
      }
    ],
    resourceType: [
      {
        required: true,
        message: '资源类型不能为空',
        trigger: ['blur', 'change']
      }
    ],
    relatedRecordId: [
      {
        required: true,
        message: '请选择服务资源',
        trigger: ['blur', 'change']
      }
    ],
    serviceCrewId: [
      {
        required: true,
        message: '请选择服务资源',
        trigger: ['blur', 'change']
      }
    ],
    estimatedDuration: [
      {
        required: true,
        message: '估计工期不能为空',
        trigger: ['blur', 'change']
      }
    ],
    price: [
      {
        required: true,
        message: '价格不能为空',
        trigger: 'blur'
      }
    ],
    unit: [
      {
        required: true,
        message: '单位不能为空',
        trigger: ['blur', 'change']
      }
    ],
    productType: [
      {
        required: true,
        message: '产品类型不能为空',
        trigger: ['blur', 'change']
      }
    ],
    primaryCode: [
      {
        required: true,
        message: '串码不能为空',
        trigger: 'blur'
      }
    ],
    productId: [
      {
        required: true,
        message: '产品名称不能为空',
        trigger: ['blur', 'change']
      }
    ],
    area: [
      {
        required: true,
        message: '省市区不能为空',
        trigger: ['blur', 'change']
      }
    ],
    spec: [
      {
        required: true,
        message: '规格不能为空',
        trigger: 'blur'
      }
    ],
    model: [
      {
        required: true,
        message: '型号不能为空',
        trigger: 'blur'
      }
    ],
    partnerIds: [
      {
        required: true,
        message: '型号不能为空',
        trigger: ['blur', 'change']
      }
    ]

    /*minimumCrewSize: [
      {
        required: true,
        message: "最小工作人数不能为空",
        trigger: ["blur", "change"]
      }
    ],
    recommendedCrewSize: [
      {
        required: true,
        message: "推荐工作人数不能为空",
        trigger: ["blur", "change"]
      }
    ],*/
  },
  // 富文本编辑器
  vqeditor: {
    content: '',
    editorOption: {
      theme: 'snow',
      placeholder: '',
      modules: {
        //工具栏
        toolbar: {
          container: [
            //加粗，斜体，下划线，删除线
            ['bold', 'italic', 'underline', 'strike'],
            //引用，代码块
            // ['blockquote', 'code-block'],
            // 标题，键值对的形式；1、2表示字体大小
            [
              {
                header: 1
              },
              {
                header: 2
              }
            ],
            //列表
            [
              {
                list: 'ordered'
              },
              {
                list: 'bullet'
              }
            ],
            //对齐方式
            [
              {
                align: []
              }
            ],
            // [{ script: 'sub' }, { script: 'super' }], // 上下标
            // [{ indent: '-1' }, { indent: '+1' }], // 缩进
            // [{ direction: 'rtl' }], // 文本方向
            [{ size: ['12px', '14px', false, '18px', '22px', '26px', '30px', '36px', '42px'] }], // 字体大小
            // [{ header: [1, 2, 3, 4, 5, 6, false] }], //几级标题
            // 字体颜色，字体背景颜色，字体
            [
              {
                color: []
              },
              {
                background: []
              }
              // {
              //   font: fonts
              // }
            ],
            ['clean'], //清除字体样式
            ['link', 'image']
          ],
          handlers: {
            image: function(value) {
              if (value) {
                // upload点击上传事件
                if (document.querySelector('.quill-uploader input')) {
                  document.querySelector('.quill-uploader input').click();
                }
              } else {
                this.quill.format('image', false);
              }
            }
          }
        }
      }
    }
  },
  // 渲染自定义字段值类型
  renderExtField(extFields, row) {
    row.exts = row.exts || {};
    for (let field of extFields) {
      if (field.type == 'rate') {
        row.exts[field.name] = Number(row.exts[field.name]) || 5;
      } else if (
        field.type == 'checkbox' ||
        field.type == 'cascade' ||
        (field.type == 'request' &&
          (field.frontEndConfig.componentType == 'checkbox' ||
            field.frontEndConfig.componentType == 'table' ||
            field.multiple)) ||
        field.frontEndConfig.isJson
      ) {
        if (field.preset == '1') {
          if (row[field.name]) {
            if (util.isJson(row[field.name])) row[field.name] = JSON.parse(row[field.name]);
          } else {
            row[field.name] = [];
          }
        } else {
          if (row.exts[field.name]) {
            if (util.isJson(row.exts[field.name]))
              row.exts[field.name] = JSON.parse(row.exts[field.name]);
          } else {
            row.exts[field.name] = [];
          }
        }
      } else if (field.type == 'file') {
        if (util.isJson(row.exts[field.name]))
          row.exts[field.name] = JSON.parse(row.exts[field.name]);
        if (Array.isArray(row.exts[field.name])) {
          let arr = [];
          for (let index = 0; index < row.exts[field.name].length; index++) {
            let item = row.exts[field.name][index];
            if (item) {
              if (item.response) {
                if (item.response.key) {
                  item.url =
                    window.$this.osg.downloadUrl == '/'
                      ? item.response.key
                      : window.$this.osg.downloadUrl +
                        item.response.key.replace(window.$this.osg.downloadUrl, '');
                } else if (item.response.data && item.response.data.url) {
                  item.url =
                    window.$this.osg.downloadUrl == '/'
                      ? item.response.key
                      : window.$this.osg.downloadUrl +
                        item.response.data.url.replace(window.$this.osg.downloadUrl, '');
                }
              } else {
                item = {
                  name: item.name,
                  uid: index + new Date().valueOf(),
                  url:
                    window.$this.osg.downloadUrl == '/'
                      ? item.url
                      : window.$this.osg.downloadUrl +
                        item.url.replace(window.$this.osg.downloadUrl, ''),
                  response: {
                    key: item.url
                  }
                };
              }
              arr.push(item);
            }
          }
          row.exts[field.name] = arr;
        } else {
          row.exts[field.name] = [];
        }
      }
    }
    return row;
  },
  // query接口解析字段
  renderExtFields(extFields, rows) {
    for (let i = 0; i < rows.length; i++) {
      rows[i].exts = rows[i].exts || {};
      for (let field of extFields) {
        if (field.type == 'rate') {
          rows[i].exts[field.name] = Number(rows[i].exts[field.name]) || 5;
        } else if (
          field.type == 'checkbox' ||
          field.type == 'cascade' ||
          field.frontEndConfig.isJson
        ) {
          if (rows[i].exts[field.name]) {
            if (util.isJson(rows[i].exts[field.name]))
              rows[i].exts[field.name] = JSON.parse(rows[i].exts[field.name]);
          } else {
            rows[i].exts[field.name] = [];
          }
        }
      }
    }
    return rows;
  },
  // 渲染自定义表单字段
  renderExtFormFields(fields, rows) {
    for (let i = 0; i < rows.length; i++) {
      for (let field of fields) {
        if (field.type == 'rate') {
          rows[i][field.name] = Number(rows[i][field.name]) || 5;
        } else if (field.type == 'checkbox' || field.type == 'cascade') {
          if (rows[i][field.name]) {
            if (util.isJson(rows[i][field.name]))
              rows[i][field.name] = JSON.parse(rows[i][field.name]);
          } else {
            rows[i][field.name] = [];
          }
        }
      }
    }
    return rows;
  },
  // 解决自定义字段不能传数组
  saveExtField(extFields, row) {
    for (let field of extFields) {
      if ((field.preset == '1' && field.type != 'area') || field.frontEndConfig.salesAttribute)
        continue;
      if (field.name == 'productBizType') continue; // 冗余存储产品类型数组
      if (
        field.type == 'checkbox' ||
        field.type == 'cascade' ||
        field.multiple ||
        field.frontEndConfig.isJson
      ) {
        row.exts[field.name] = JSON.stringify(row.exts[field.name]);
      } else if (field.type == 'file') {
        if (Array.isArray(row.exts[field.name])) {
          row.exts[field.name] = JSON.stringify(
            row.exts[field.name].map(item => {
              return {
                url:
                  window.$this.osg.downloadUrl +
                  item.response.key.replace(window.$this.osg.downloadUrl, ''),
                name: item.response.key
              };
            })
          );
        } else {
          row.exts[field.name] = [];
        }
      } else if (field.type == 'area') {
        row.area = row.area || [];
        row.province = '';
        row.city = '';
        row.district = '';
        // row.subdistrict = '';
        if (row.area.length > 0) {
          row.province = row.area[0] || '';
          if (row.area.length > 1) {
            row.city = row.area[1] || '';
            if (row.area.length > 2) {
              row.district = row.area[2] || '';
              if (row.area.length > 3) {
                row.subdistrict = row.area[3] || '';
              }
            }
          }
        }
      }
    }
    return row;
  },
  // 自定义字段转换值,不返回JSON串
  saveFormatExtField(extFields, row) {
    for (let field of extFields) {
      if (field.type == 'file') {
        if (field.preset == '1') {
          if (Array.isArray(row[field.name])) {
            row[field.name] = row[field.name].map(item => {
              if (item.response) {
                if (item.response.key) {
                  return {
                    url:
                      window.$this.osg.downloadUrl == '/'
                        ? item.url
                        : window.$this.osg.downloadUrl +
                          item.response.key.replace(window.$this.osg.downloadUrl, ''),
                    name: item.response.key
                  };
                } else if (item.response.data) {
                  return {
                    url: item.response.data.url,
                    name: item.name
                  };
                }
              } else {
                return {
                  url:
                    window.$this.osg.downloadUrl == '/'
                      ? item.url
                      : window.$this.osg.downloadUrl +
                        item.url.replace(window.$this.osg.downloadUrl, ''),
                  name: item.name
                };
              }
            });
            // 冗余存储文件链接
            let imageUrls = [];
            row[field.name].map(item => {
              imageUrls.push(item.url || '');
            });
            if (imageUrls.length > 1) {
              row[field.name + 'Urls'] = imageUrls;
            } else {
              row[field.name + 'Url'] = imageUrls.join();
            }
          } else {
            row[field.name] = [];
          }
        } else {
          if (Array.isArray(row.exts[field.name])) {
            row.exts[field.name] = row.exts[field.name].map(item => {
              if (item.response) {
                if (item.response.key) {
                  return {
                    url:
                      window.$this.osg.downloadUrl == '/'
                        ? item.url
                        : window.$this.osg.downloadUrl +
                          item.response.key.replace(window.$this.osg.downloadUrl, ''),
                    name: item.response.key
                  };
                } else if (item.response.data) {
                  return {
                    url: item.response.data.url,
                    name: item.name
                  };
                }
              } else {
                return {
                  url:
                    window.$this.osg.downloadUrl == '/'
                      ? item.url
                      : window.$this.osg.downloadUrl +
                        item.url.replace(window.$this.osg.downloadUrl, ''),
                  name: item.name
                };
              }
            });
            // 冗余存储文件链接
            let imageUrls = [];
            row.exts[field.name].map(item => {
              imageUrls.push(item.url || '');
            });
            if (imageUrls.length > 1) {
              row.exts[field.name + 'Urls'] = imageUrls;
            } else {
              row.exts[field.name + 'Url'] = imageUrls.join();
            }
          } else {
            row.exts[field.name] = [];
          }
        }
      }
      if (field.preset == '1') continue;
      if (field.frontEndConfig.copy == 'flat') {
        if (row.exts[field.name] && Array.isArray(row.exts[field.name])) {
          row.exts[field.name + '_copy'] = row.exts[field.name].flat();
        } else {
          row.exts[field.name + '_copy'] = [];
        }
      }
    }
    return row;
  },
  /**
   * 判断是否json
   * @param $string
   * @returns {boolean}
   */
  isJson($string) {
    try {
      if (typeof JSON.parse($string) == 'object') return true;
      return false;
    } catch (e) {
      return false;
    }
  },
  //给body加类名,个性化主题
  toggleClass(element, className) {
    document.body.removeAttribute('class');
    if (!element || !className) {
      return;
    }
    let classString = element.className;
    const nameIndex = classString.indexOf(className);
    if (nameIndex === -1) {
      classString += '' + className;
    } else {
      classString =
        classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
    }
    element.className = classString;
  },
  //返回可读时间
  readableTime(val, type) {
    let date = val ? new Date(val) : new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();
    let dateStr =
      year +
      '-' +
      util.fillZero(month) +
      '-' +
      util.fillZero(day) +
      ' ' +
      util.fillZero(hour) +
      ':' +
      util.fillZero(minute) +
      ':' +
      util.fillZero(second);
    if (type == 'date') {
      return dateStr.slice(0, dateStr.indexOf(' '));
    } else {
      return dateStr;
    }
  },
  //补零
  fillZero(num) {
    return num < 10 ? '0' + num : num;
  },
  customizeMenuChange(newValue) {
    switch (newValue) {
      case 'red':
        util.toggleClass(document.body, 'custom-theme-bg-red');
        break;
      case 'green':
        util.toggleClass(document.body, 'custom-theme-bg-green');
        break;
      case 'blue':
        util.toggleClass(document.body, 'custom-theme-bg-blue');
        break;
      default:
        util.toggleClass(document.body, '');
    }
  },
  //用于扩展字段，判断如果配置了因为某个字段值才显示
  isShowField(obj, field, showField, showValue) {
    // obj 表单数据
    // field 表单字段
    try {
      showField = showField || (field.frontEndConfig && field.frontEndConfig.showField);
      showValue = showValue || (field.frontEndConfig && field.frontEndConfig.showValue) || '';
      if (!showField) return true; //都没有配置直接返回true
      if (showValue === '$notexist') {
        if (showField.indexOf('exts.') != -1) {
          if (!obj.exts[showField]) {
            return true;
          } else {
            return false;
          }
        } else {
          if (!obj[showField]) {
            return true;
          } else {
            return false;
          }
        }
      } else if (showValue === '$exist') {
        if (obj[showField]) return true;
        obj.exts = obj.exts || {};
        if (obj.exts[showField]) return true;
      } else {
        if (
          obj[showField] &&
          (obj[showField] == showValue ||
            (Array.isArray(obj[showField])
              ? obj[showField].flat().indexOf(showValue) !== -1
              : Array.isArray(showValue)
              ? showValue.flat().indexOf(obj[showField]) != -1
              : false))
        ) {
          return true;
        }
        obj.exts = obj.exts || {};
        if (obj.exts[showField]) {
          if (obj.exts[showField] == showValue) {
            return true;
          } else if (
            Array.isArray(obj.exts[showField])
              ? obj.exts[showField].flat().indexOf(showValue) !== -1
              : Array.isArray(showValue)
              ? showValue.flat().indexOf(obj.exts[showField]) != -1
              : false
          ) {
            return true;
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  },
  formTrim(type = null, valueStr = '', replaceStr = '') {
    let resultStr = '';
    new RegExp('\\s+');
    switch (type) {
      case 'replace':
        resultStr = valueStr.replace(replaceStr, '');
        break;
      case 'replaceAll':
        resultStr = valueStr.replaceAll(replaceStr, '');
        break;
      case 'replaceReg':
        resultStr = valueStr.replace(replaceStr, '');
        break;
      case 'replaceRegAll':
        resultStr = valueStr.replaceAll(new RegExp(replaceStr) + 'g', '');
        break;
    }
    return resultStr;
  }
};
export default {
  util
};
